/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Btn_CheckInputs */

const en_rd_btn_check = /** @type {(inputs: Rd_Btn_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score my repo`)
};

const id_rd_btn_check = /** @type {(inputs: Rd_Btn_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai repo saya`)
};

/**
* | output |
* | --- |
* | "Score my repo" |
*
* @param {Rd_Btn_CheckInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_btn_check = /** @type {((inputs?: Rd_Btn_CheckInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Btn_CheckInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_btn_check(inputs)
	return en_rd_btn_check(inputs)
});